import { actionTypes } from '@/core/constants'
import PenalidadesUrlBuilder from '@/core/utils/factory/penalidades/PenalidadesUrlBuilder'
import PenalidadesDadosGeraisApiClient from '@/core/apiclient/penalidades/dados-gerais/PenalidadesDadosGeraisApiClient'

function getApiClient(obj) {
	const urlBuilder = new PenalidadesUrlBuilder(obj.tipo)
	return new PenalidadesDadosGeraisApiClient(urlBuilder)
}

export default {
	async [actionTypes.PENALIDADES.BUSCAR_ORGAOS_SANCIONADORES_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarOrgaosSancionadoresPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.BUSCAR_FORNECEDORES_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarFornecedoresPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.BUSCAR_TIPOS_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarTiposPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.SALVAR_DADOS_GERAIS_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.salvarDadosGeraisPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.BUSCAR_DADOS_GERAIS_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarDadosGeraisPenalidade(objt)
		return data
	},
}
